<article class="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-1 g-4" *ngIf="ServiceTargetedSector.length>0">
    <div class="col d-flex align-items-stretch" *ngFor="let item of ServiceTargetedSector">
        <div class="card border-0 shadow-primary bg-primary w-100">
            <div class="card-body py-5 px-2 d-flex flex-column justify-content-center align-items-center">
                <p class="fs-sm fw-normal text-white mb-0 text-center">
                    {{item.ItemFields?.TargetedSector}}</p>
            </div>
        </div>
    </div>
</article>